import { render, staticRenderFns } from "./HomeObserveCard.vue?vue&type=template&id=3f7a127d&scoped=true"
import script from "./HomeObserveCard.vue?vue&type=script&lang=js"
export * from "./HomeObserveCard.vue?vue&type=script&lang=js"
import style0 from "./HomeObserveCard.vue?vue&type=style&index=0&id=3f7a127d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7a127d",
  null
  
)

export default component.exports